import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import { devtools } from 'zustand/middleware'
import { TEAM_TYPES } from '@/data/constants/constants'

let store = immer((set, get) => ({
  currentStep: null,
  teamType: TEAM_TYPES.BUSINESS,
  [TEAM_TYPES.BUSINESS]: {
    teamType: 'Business',
    name: '',
    // budgetingPeriod: '', //Week or Month
    // balance: null,
    // dateAsOf: null,
    steps: [
      {
        id: 1,
        title: 'Set up your business space',
        description: 'Enter your business name to get started with ProfitFlow.',
        component: 'AboutYourBusiness',
      },
      // {
      //   id: 2,
      //   title: 'Manage your business finances',
      //   description:
      //     'Thank you for signing in for ProfitFlow. This setup wizard will help you to navigate through the setup process',
      //   component: 'CreateVault',
      // },
    ],
  },

  [TEAM_TYPES.PERSONAL]: {
    teamType: 'Personal',
    name: undefined,
    // balance: null,
    // dateAsOf: null,
    steps: [
      // {
      //   id: 1,
      //   title: 'Manage your business finances',
      //   description:
      //     'Thank you for signing in for ProfitFlow. This setup wizard will help you to navigate through the setup process',
      //   component: 'CreateVault',
      // },
    ],
  },

  getData: () => {
    return get()[get().teamType]
  },
  isLastPage: () => {
    if (get().teamType === null) return false // safety guard

    const steps = get()[get().teamType]?.steps ?? []
    if (steps.length === 0) return true

    // When currentStep is null and there's only 1 step, the first render IS
    // the submit screen — the null-state and the only step are the same screen.
    if (get().currentStep === null) return steps.length === 1

    return steps[steps.length - 1].id === get().currentStep?.id
  },

  setTeamType: (val) => {
    set((state) => {
      state.teamType = val
    })
  },
  setTeamTypeSettings: (val) => {
    set((state) => {
      state[state.teamType] = { ...state[state.teamType], ...val }
    })
  },
  moveNextStep: () => {
    set((state) => {
      if (state.currentStep === null) {
        state.currentStep = state[state.teamType].steps[0]
      } else {
        const cid = state.currentStep.id
        const steps = state[state.teamType].steps
        const step = steps.find((x) => x.id > cid)
        if (step) {
          state.currentStep = step
        }
      }
    })
  },
  movePreviousStep: () => {
    set((state) => {
      if (state.currentStep === null) return
      const step = state[state.teamType]?.steps.find(
        (x) => x.id < state.currentStep.id,
      )
      state.currentStep = step ?? null
    })
  },
  isAuthenticated: false,
  count: 0,
  authenticate: (val) => {
    set((state) => {
      state.isAuthenticated = val
    })
  },
  increment: (qty) =>
    set((state) => {
      state.count += qty
    }),
  decrement: (qty) =>
    set((state) => {
      state.count -= qty
    }),
}))

store = devtools(store)

// store = persist(store, {
//   name: 'setup-store',
//   getStorage: () => sessionStorage,
// })

const useSetupStore = create(store)

export default useSetupStore
